module.exports = "../dist/img/3.3c64.jpeg";